import { OrderResponse } from '../../fetch/types';
import { Item } from '../../types/order';

function validateQuantity(items: Array<Item>) {
  return items.reduce((validItems, item) => {
    if (
      (item.qty && item.qty > 0) ||
      (item.qty === 0 && item?.non_return_reason)
    ) {
      validItems.push(item);
    }
    return validItems;
  }, [] as Array<Item>);
}

function removeAlreadyRefundedItems(items: Array<Item>) {
  return items.reduce((validItems, item) => {
    const i = {
      ...item,
      qty_refunded: item.qty_refunded || 0,
      qty_returned: item.qty_returned || 0,
    };

    // Only update item quantity if quantity refunded has not been factored into quantity
    if (i.qty_refunded > i.qty_returned) {
      i.qty -= i.qty_refunded - i.qty_returned;
    }

    if (i.qty > 0 || (i.qty === 0 && i?.non_return_reason)) {
      validItems.push(i);
    }

    return validItems;
  }, [] as Array<Item>);
}

export default function isValidReturn(response: OrderResponse) {
  const orderData = response?.shippit_connect_purchase_data?.return_request;
  if (!orderData) return false;
  orderData.items = validateQuantity(orderData.items);
  orderData.items = removeAlreadyRefundedItems(orderData.items);

  return !(orderData.items.length === 0);
}
